export default "__VITE_ASSET__e4756bbd__"